import PropTypes from 'prop-types';
import React from 'react';

import Container from '../../layout/Container';
import SectionTitle from '../SectionTitle/SectionTitle';
import { translateLocal } from '../../../i18n';

import './HomeArgumentsBlock.scss';

const HomeArgumentsBlock = ({ data }) => {

  const [hoveredIndex, setHoveredIndex] = React.useState(0);

  return (
    <div className="home-arguments-block">
      <Container>
        <SectionTitle
          title={translateLocal(data.title)}
          subtitle={translateLocal(data.subtitle)}
        />
      </Container>

      <div className="content-cols">
        <Container>
          <div className="image-col">
            <div className="image-wrapper">
              {data?.items?.map((item, index) => (
                <img key={index} src={item.image.src} className={`image ${index === hoveredIndex ? 'visible' : ''}`} alt={translateLocal(item.title)} />
              ))}
            </div>
          </div>

          <div className="content-col">
            {data?.items?.map((item, index) => (
              <div key={index} className={`item-content ${index === hoveredIndex ? 'hovered' : ''}`} onMouseEnter={() => setHoveredIndex(index)}>
                <h3 className="item-title">{translateLocal(item.title)}</h3>

                <p className="item-text text-muted">{translateLocal(item.text)}</p>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
};

HomeArgumentsBlock.propTypes = {
  data: PropTypes.object.isRequired,
};

export default HomeArgumentsBlock;
